<div class="sidebar-modern d-flex bg-white shadow border-top"
 :class="{ collapsed: is_collapsed, 'drive-route-collapsed': is_drive_route }">
  <!-- Collapse Toggle Button -->
  <button 
    class="collapse-toggle position-fixed align-items-center shadow bg-white border border-secondary rounded-end"
    @click.stop="toggle_collapse" 
    @mousedown.prevent
    type="button"
    aria-label="Toggle sidebar"
  >
    <div :class="{ 'rotated': settings_menu_open }">
      <i class="fa-solid fa-chevron-left" aria-hidden="true"></i>
    </div>
  </button>

  <!-- Logo Section -->
  <div class="sidebar-header">
    <div class="logo-container d-flex">
      <img :src="get_sidebar_logo_src()" alt="AIC ONE" class="main-logo">
    </div>
  </div>

  <!-- App Launcher -->
  <div class="app-launcher-section">
    <div class="dropdown">
      <button 
        class="app-launcher-btn d-flex"
        data-tooltip="My Apps"
        type="button" 
        id="app_launcher_btn" 
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <span class="app-launcher-nine-dot launcher-icon" aria-hidden="true">
          <span></span><span></span><span></span>
          <span></span><span></span><span></span>
          <span></span><span></span><span></span>
        </span>
        <span class="launcher-text">My Apps</span>
      </button>

      <div class="dropdown-menu app-grid-dropdown bg-white" aria-labelledby="app_launcher_btn">
        <div class="app-grid bg-white">
          <a v-if="allowed_app_keys.includes('orcaa')" class="app-item d-flex" @click="launch_platform('orcaa')">
            <div class="app-icon-wrapper d-flex">
              <img :src="require('@/assets/platforms_icons/orcaa_ai.svg')" alt="Orcaa">
            </div>
          </a>

          <a v-if="allowed_app_keys.includes('workflow')" class="app-item d-flex" @click="launch_platform('workflow')">
            <div class="app-icon-wrapper d-flex">
              <img :src="require('@/assets/platforms_icons/ProbaWorkflows.png')" alt="Workflows">
            </div>
          </a>

          <a v-if="allowed_app_keys.includes('complyon')" class="app-item d-flex" @click="launch_platform('complyon')">
            <div class="app-icon-wrapper d-flex">
              <img :src="require('@/assets/platforms_icons/complyon.svg')" alt="Complyon">
            </div>
          </a>
          <a v-if="allowed_app_keys.includes('engagenet')" class="app-item d-flex" @click="launch_platform('engagenet')">
            <div class="app-icon-wrapper d-flex">
              <img :src="require('@/assets/platforms_icons/engagenet.svg')"
                :alt="is_internal_suite ? 'IC Workbook' : 'Engagenet'">
            </div>
          </a>

          <a v-if="allowed_app_keys.includes('x-verdict')" class="app-item d-flex" @click="launch_platform('x-verdict')">
            <div class="app-icon-wrapper d-flex">
              <img :src="require('@/assets/platforms_icons/x-verdict.svg')" alt="X-Verdict">
            </div>
          </a>

          <a v-if="allowed_app_keys.includes('proba')" class="app-item d-flex" @click="launch_platform('proba')">
            <div class="app-icon-wrapper d-flex">
              <img :src="require('@/assets/platforms_icons/proba-analytics.svg')" alt="Analytics">
            </div>
          </a>
          <a v-if="allowed_app_keys.includes('complyon_onboard')" class="app-item d-flex" @click="launch_platform('complyon_onboard')">
            <div class="app-icon-wrapper d-flex">
              <img :src="require('@/assets/platforms_icons/Onboardid.png')" alt="OnboardID">
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="sidebar-scroll-area">
    <!-- Main Navigation -->
    <nav class="sidebar-nav position-relative" aria-label="Primary navigation">
    <router-link to="/home" class="nav-item d-flex" active-class="active" data-tooltip="Home">
      <div class="nav-icon d-flex">
        <i class="fa-solid fa-house" aria-hidden="true"></i>
      </div>
      <span class="nav-label">Home</span>
    </router-link>

    <router-link to="/ziva" class="nav-item d-flex" active-class="active" data-tooltip="Ziva Assistant">
      <div class="nav-icon d-flex">
        <i class="fa-solid fa-wand-magic-sparkles" aria-hidden="true"></i>
      </div>
      <span class="nav-label nav-label-desktop">Ziva Assistant</span>
      <span class="nav-label nav-label-mobile">Ziva</span>
    </router-link>

    <router-link to="/create" class="nav-item d-flex" active-class="active" data-tooltip="Projects & Workspaces">
      <div class="nav-icon d-flex">
        <i class="fa-solid fa-briefcase" aria-hidden="true"></i>
      </div>
      <span class="nav-label nav-label-desktop">Projects & Workspace</span>
      <span class="nav-label nav-label-mobile">Workspaces</span>
    </router-link>

    <router-link to="/drive" class="nav-item d-flex" active-class="active" data-tooltip="Documents & Storage">
      <div class="nav-icon d-flex">
        <i class="fa-solid fa-folder" aria-hidden="true"></i>
      </div>
      <span class="nav-label nav-label-desktop">Documents & Storage</span>
      <span class="nav-label nav-label-mobile">Drive</span>
    </router-link>

    <router-link to="/chat" class="nav-item d-flex d-lg-none" active-class="active" data-tooltip="Chat">
      <div class="nav-icon d-flex position-relative">
        <i class="fa-solid fa-message" aria-hidden="true"></i>
        <span
          v-if="unread_chat_count > 0"
          class="sidebar-chat-badge"
        >
          {{ unread_chat_count > 99 ? '99+' : unread_chat_count }}
        </span>
      </div>
      <span class="nav-label">Chat</span>
    </router-link>

    <router-link to="/audit_trail" class="nav-item d-flex" active-class="active" data-tooltip="Governance & Security">
      <div class="nav-icon d-flex">
        <i class="fa-solid fa-list-check" aria-hidden="true"></i>
      </div>
      <span class="nav-label">Activity</span>
    </router-link>

    <router-link to="/support" class="nav-item d-flex d-none" active-class="active" data-tooltip="Support & Community">
      <div class="nav-icon d-flex">
        <i class="fa-regular fa-circle-question" aria-hidden="true"></i>
      </div>
      <span class="nav-label">Support & Community</span>
    </router-link>

    <!-- Settings with Expandable Submenu -->
    <div v-if="is_admin" class="nav-item-wrapper w-100">
      <button
        class="nav-item settings-menu-toggle d-flex flex-column align-items-center justify-content-center position-relative w-100 border-0 bg-transparent"
        data-tooltip="Settings"
        :class="{ active: settings_menu_open }"
        @click="toggle_settings_menu"
        type="button"
        :aria-expanded="settings_menu_open ? 'true' : 'false'"
        aria-controls="admin_settings_submenu"
      >
        <div class="nav-icon d-flex align-items-center justify-content-center">
          <i class="fa-solid fa-sliders" aria-hidden="true"></i>
        </div>
        <span class="nav-label">
          Settings
        </span>
        <i
          class="submenu-arrow fas fa-chevron-down position-absolute d-inline-flex align-items-center justify-content-center"
          :class="{ 'rotate-180': settings_menu_open }"
          aria-hidden="true"
        ></i>
      </button>

      <div
        id="admin_settings_submenu"
        class="nav-submenu"
        :class="{ 'open': settings_menu_open }"
      >
        <router-link
          to="/profile" 
          class="submenu-item d-flex" 
          active-class="active"
          @click.native="close_settings_menu_on_mobile"
        >
          <div class="submenu-icon d-flex">
            <i class="fa-regular fa-user" aria-hidden="true"></i>
          </div>
          <span class="nav-label submenu-label-mobile">Profile</span>
        </router-link>

        <router-link
          to="/permission"
          class="submenu-item d-flex"
          active-class="active"
          @click.native="close_settings_menu_on_mobile"
        >
          <div class="submenu-icon d-flex">
            <i class="fa-solid fa-shield-halved" aria-hidden="true"></i>
          </div>
          <span class="nav-label submenu-label-mobile">Permissions</span>
        </router-link>

        <router-link
          to="/role"
          class="submenu-item d-flex"
          active-class="active"
          @click.native="close_settings_menu_on_mobile"
        >
          <div class="submenu-icon d-flex">
            <i class="fa-solid fa-id-badge" aria-hidden="true"></i>
          </div>
          <span class="nav-label submenu-label-mobile">Roles</span>
        </router-link>

        <router-link
          to="/settings"
          class="submenu-item d-flex"
          active-class="active"
          @click.native="close_settings_menu_on_mobile"
        >
          <div class="submenu-icon d-flex">
            <i class="fa-solid fa-users" aria-hidden="true"></i>
          </div>
          <span class="nav-label submenu-label-mobile">Users</span>
        </router-link>

        <router-link
          to="/access_control"
          class="submenu-item d-flex d-none"
          active-class="active"
          @click.native="close_settings_menu_on_mobile"
        >
          <div class="submenu-icon d-flex">
            <i class="fa-solid fa-user-lock" aria-hidden="true"></i>
          </div>
          <span class="nav-label submenu-label-mobile">Access Control</span>
        </router-link>

        <router-link
          to="/system_configure"
          class="submenu-item d-flex "
          active-class="active"
          @click.native="close_settings_menu_on_mobile"
        >
          <div class="submenu-icon d-flex">
            <i class="fa-solid fa-screwdriver-wrench" aria-hidden="true"></i>
          </div>
          <span class="nav-label submenu-label-mobile">System Configure</span>
        </router-link>

        <router-link
          to="/platform_management"
          class="submenu-item d-flex d-none"
          active-class="active"
          @click.native="close_settings_menu_on_mobile"
        >
          <div class="d-flex launcher-icon" >
            <i class="fa-solid fa-table-cells-large" aria-hidden="true"></i>
          </div>
          <span class="nav-label submenu-label-mobile">Platform Management</span>
        </router-link>

        <router-link
          to="/superset_manager"
          class="submenu-item d-flex d-none"
          active-class="active"
          @click.native="close_settings_menu_on_mobile"
        >
          <div class="submenu-icon d-flex">
            <i class="fa-solid fa-chart-column" aria-hidden="true"></i>
          </div>
          <span class="nav-label submenu-label-mobile">Manage Superset</span>
        </router-link>

        <router-link
          to="/main_settings"
          class="submenu-item d-flex d-none"
          active-class="active"
          @click.native="close_settings_menu_on_mobile"
        >
          <div class="submenu-icon d-flex">
            <i class="fa-solid fa-gear" aria-hidden="true"></i>
          </div>
          <span class="nav-label submenu-label-mobile">General Settings</span>
        </router-link>

      </div>

      <div
        v-if="settings_menu_open"
        class="submenu-overlay d-block d-sm-none"
        @click="close_settings_menu_on_mobile"
      ></div>
    </div>
    </nav>

    <!-- Logout Section -->
    <div v-if="should_show_logout" class="sidebar-footer">
      <button class="logout-btn d-flex" data-tooltip="Logout" @click="logout()">
        <div class="nav-icon">
          <i class="fa-solid fa-arrow-right-from-bracket" aria-hidden="true"></i>
        </div>
        <span class="nav-label">Logout</span>
      </button>
    </div>
  </div>
</div>
